import { FeatureFlags } from '@iot-platform/models/common';

export const commonEnvironment = {
  production: false,
  envName: 'Dev',
  envType: 'dev',
  sso: {
    subdomain: 'iot4bos-dev',
    domain: 'https://iot4bos-dev.auth.eu-west-1.amazoncognito.com',
    clientId: '4d8bpmnelnf2mkljakfakrvpub',
    idpIdentifier: 'okta',
    responseType: 'code',
    redirectUri: 'login/callback'
  },
  cognito: {
    region: 'eu-west-1',
    userPoolId: 'eu-west-1_3kPklo82Y',
    clientId: '4d8bpmnelnf2mkljakfakrvpub'
  },
  api: {
    url: '/api/v1',
    url_v2: '/api/v2',
    url_connector: '/api-connector/v1',
    key: '',
    releaseNotesUrl: 'https://cdn.bos.iot.airliquide.com/nte/release-notes.html',
    endpoints: {
      assetVariablesUnits: '/asset-variables/unit_json',
      nteDevices: '/devices?deviceIncomingConnectorId=NTE003',
      devices: '/devices',
      deviceDetails: '/device-details',
      deviceTemplates: '/device-templates',
      peripherals: '/catalogs/peripherals',
      entities: '/entities',
      users: '/users',
      usersLightWeight: '/directory/users',
      affiliates: '/directory/entity-affiliates',
      operators: '/directory/device-operators',
      timezones: '/directory/windows/timezones',
      tags: '/tag-categories',
      deviceOperations: '/operations/devices',
      operatorInfo: '/operator-info',
      devicesBulkSendCommands: '/operations/devices/bulk-send-commands',
      directories: '/directories',
      poEventAlgos: '/po-event/algos'
    },
    connectorId: 'NTE003',
    connectorTargetOrigin: 'https://dev.i4b.io/'
  },
  storage: {
    appPrefix: 'nte'
  },
  apiKeys: {
    agGrid:
      'Using_this_{AG_Grid}_Enterprise_key_{AG-072579}_in_excess_of_the_licence_granted_is_not_permitted___Please_report_misuse_to_legal@ag-grid.com___For_help_with_changing_this_key_please_contact_info@ag-grid.com___{ALIZENT_INTERNATIONAL}_is_granted_a_{Multiple_Applications}_Developer_License_for_{1}_Front-End_JavaScript_developer___All_Front-End_JavaScript_developers_need_to_be_licensed_in_addition_to_the_ones_working_with_{AG_Grid}_Enterprise___This_key_has_not_been_granted_a_Deployment_License_Add-on___This_key_works_with_{AG_Grid}_Enterprise_versions_released_before_{12_January_2027}____[v3]_[01]_MTc5OTcxMjAwMDAwMA==7e14622e3e03c3c787c4a2329ae238a3'
  },
  featureFlags: {
    [FeatureFlags.UploadToGoogleDrive]: true,
    [FeatureFlags.DeviceDetailsConnectionSection]: false,
    [FeatureFlags.NavigateConnectorToIot4bos]: true
  },
  googleDrive: {
    clientId: '1019184160425-oj0littqmvmu1kmht782gmfj91rtr9hh.apps.googleusercontent.com',
    apiKey: 'AIzaSyC2PwXe3s3qsivOstg2QYHIU2a6eI4GhEA',
    scopes: 'https://www.googleapis.com/auth/drive.file',
    discoveryDocs: ['https://www.googleapis.com/discovery/v1/apis/drive/v3/rest'],
    uploadUri: 'https://www.googleapis.com/upload/drive/v3/files?uploadType=multipart&fields=id,name,mimeType,webViewLink',
    fileUri: 'https://drive.google.com/file/d/{{id}}/view',
    clientScriptUri: 'https://accounts.google.com/gsi/client',
    apiScriptUri: 'https://apis.google.com/js/api.js'
  }
};
